import React from "react";
import { CustomGrid } from "@/components";
import { CustomGridProps } from "@/types/AppTypes";
import { cn } from "@/lib/utils";

const BrandGrid: React.FC<CustomGridProps> = ({
  sectionHeader = null,
  gridItems = [],
  className = "",
  GridItemClassName = "", 
  loading = false,
  skeletonCount = 8,
}) => {
  return (
    <>
      <CustomGrid
        gridItems={gridItems}
        className={cn("grid-cols-2  px-6", className)}
        GridItemClassName={GridItemClassName}
        sectionHeader={sectionHeader}
        cardLink="/brand"
        loading={loading}
        skeletonCount={skeletonCount}
      />
    </>
  );
};

export default BrandGrid;
